export const env = {
  /**
   * Hostname of deployed utils, api, etc...
   * @description Leave blank to use paths relative to the production domain
   */
  DEPLOYED_HOST: "", // Leave blank to use paths relative to the production domain
  /**
   * API Host
   */
  API_HOST: "https://portal.leverageannuities.com/api/public",
  /**
   * Presentation API Host
   */
  PRESENTATION_API_HOST: "https://presentation-api.leveragerates.com/api",
  /**
   * Azure Functions Host
   */
  FUNCTIONS_HOST: "https://cms-funcs.leveragerx.com",
  /**
   * Customer.io workspace Name
   */
  CIO_WORKSPACE: "planning",
  /**
   * Google Tag Manager ID
   */
  GTM_ID: "GTM-WRN9RSC2",
  /**
   * Google Maps Platform API Key
   */
  GATSBY_GMP_API_KEY: process.env.GATSBY_GMP_API_KEY,
};

/**
 * 
 */
export const IS_DEVELOP = false;